module.exports = __webpack_public_path__ + "img/apv.f7648494.png";